import { accessToken } from "./sessionKey";
//@ts-ignore
import { AxiosInstance, API_ROOT } from "@careinfo/axios-service";

let instance:any;

// Initialize the instance before making any API calls
const initInstance = async () => {
    if (!instance) {
        instance = await AxiosInstance();
    }
};

// Get data from API
export const getApiData = async (url, param = null) => {
    await initInstance();
    let response;
    try {
        response = await instance({
            method: "GET",
            url: `${url}`,
            params: param,
            transformResponse: [
                function (responseData) {
                    // Do whatever you want to transform the data
                    return JSON.parse(responseData);
                },
            ],
        });
    } catch (e) {
        return e.response;
    }
    return response;
};

// Post data to API
export const postApiData = async (data) => {
    const { url, formData, setError } = data;
    await initInstance();
    let response;
    try {
        response = await instance({
            method: "POST",
            url: `${url}`,
            data: formData,
            headers: {
                Authorization: `JWT ${accessToken()}`,
            },
            transformResponse: [
                function (responseData) {
                    // Do whatever you want to transform the data
                    return JSON.parse(responseData);
                },
            ],
        });
    } catch (e) {
        for (const key in e.response?.data) {
            if (e.response?.data.hasOwnProperty(key)) {
                setError(key, { type: 'custom', message: e.response?.data[key] });
            }
        }
        return e.response;
    }
    return response;
};

// Update data
export const patchApiData = async (data) => {
    const { url, formData, setError } = data;
    await initInstance();
    let response;
    try {
        response = await instance({
            method: "PATCH",
            url: `${url}`,
            data: formData,
            headers: {
                Authorization: `JWT ${accessToken()}`,
            },
            transformResponse: [
                function (responseData) {
                    // Do whatever you want to transform the data
                    return JSON.parse(responseData);
                },
            ],
        });
    } catch (e) {
        for (const key in e.response?.data) {
            if (e.response?.data.hasOwnProperty(key)) {
                setError(key, { type: 'custom', message: e.response?.data[key] });
            }
        }
        return e.response;
    }
    return response;
};
export const printAPIPDF = async (data:any) => {
    const { url, formData, setError } = data;
    try {
      return await instance({
        method: "POST",
        url: `${url}`,
        data: formData,
        responseType: 'blob',
      });
    } catch (e: any) {
      return e.response;
    }
  };
  

export { API_ROOT };